import { render, staticRenderFns } from "./CardSummary.vue?vue&type=template&id=e3f88908&scoped=true"
import script from "./CardSummary.vue?vue&type=script&lang=js"
export * from "./CardSummary.vue?vue&type=script&lang=js"
import style0 from "./CardSummary.vue?vue&type=style&index=0&id=e3f88908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f88908",
  null
  
)

export default component.exports